import React from "react";

export interface RangeConfig {
  label: string;
  yValue: number;
  color: string;
  fontWeight?: number;
}

interface ReferenceRangesProps {
  yDomain: number[];
  chartHeight: number;
  yMargin: { top: number; bottom: number };
  ranges: RangeConfig[];
}

export const ReferenceRanges: React.FC<ReferenceRangesProps> = ({
  yDomain,
  chartHeight,
  yMargin,
  ranges,
}) => {
  const plotHeight = chartHeight - yMargin.top - yMargin.bottom;
  const yRange = yDomain[1] - yDomain[0];

  // Helper function to calculate Y position for a given value
  const calculateYPosition = (value: number) => {
    return yMargin.top + plotHeight * (1 - (value - yDomain[0]) / yRange);
  };

  return (
    <div style={{ position: "absolute", right: 32, top: 20 }}>
      {ranges.map((range) => {
        const topPosition = calculateYPosition(range.yValue);
        // Only show label if it's within the visible domain
        if (range.yValue < yDomain[0] || range.yValue > yDomain[1]) {
          return null;
        }
        return (
          <div
            key={range.label}
            style={{
              position: "absolute",
              top: topPosition,
              fontSize: 10,
              color: range.color,
              fontWeight: range.fontWeight || 500,
            }}
          >
            {range.label}
          </div>
        );
      })}
    </div>
  );
};
